import { formatReportDateUnix } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportInsuranceProps } from "./types";
import classes from "./report-insurance.module.scss";

export const ReportInsurance = ({ events, isPdfMode }: ReportInsuranceProps) => {
    return (
        <div className={classes["insurance"]}>
            <div className={classes["insurance__source"]}>По данным РСА и наших партнёров</div>
            {events?.length === 0 ? (
                <div className={classes.insurance__item}>
                    Данные о страховых полисах отсутствуют
                </div>
            ) : (
                events?.map((event, idx) => (
                    <FixedAccordion
                        key={idx}
                        expanded={isPdfMode}
                        title={
                            <div className={classes.insurance__item}>
                                <span>
                                    {event.startDate && formatReportDateUnix(event.startDate)}
                                </span>
                                <div className={classes.insurance__type}>ОСАГО</div>
                            </div>
                        }
                        content={
                            <>
                                <div className={classes.insurance__row}>
                                    <div className={classes.insurance__label}>Тип страховки</div>
                                    <div className={classes.insurance__value}>ОСАГО</div>
                                </div>
                                <div className={classes.insurance__row}>
                                    <div className={classes.insurance__label}>Статус</div>
                                    <div className={classes.insurance__value}>
                                        {event.status ? event.status : "-"}
                                    </div>
                                </div>
                                <div className={classes.insurance__row}>
                                    <div className={classes.insurance__label}>
                                        Страховая компания
                                    </div>
                                    <div className={classes.insurance__value}>
                                        {event.companyName ? event.companyName : "-"}
                                    </div>
                                </div>
                            </>
                        }
                    />
                ))
            )}
        </div>
    );
};